// Temp solution to avoid default limit of 10.
export const MAX_QUERY_LIMIT = 999999;
